export const NEW_MESSAGE = 'NEW_MESSAGE'
export const CHAT_STARTED = 'CHAT_STARTED'
export const CHAT_ENDED = 'CHAT_ENDED'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const NEW_USER = 'NEW_AGENT'
export const CHANGE_CHAT_SCREEN = 'CHANGE_CHAT_SCREEN'
export const UPDATE_VISITOR_QUEUE = 'UPDATE_VISITOR_QUEUE'
export const OWN_DATA_RECEIVED = 'OWN_DATA_RECEIVED'
export const CHANGE_CHAT_SERVICE = 'CHANGE_CHAT_SERVICE'
export const RATE_GOOD = 'RATE_GOOD'
export const RATE_BAD = 'RATE_BAD'
export const CHAT_RATED = 'CHAT_RATED'
export const CLOSE_CHAT = 'CLOSE_CHAT'
export const SEND_TRANSCRIPT = 'SEND_TRANSCRIPT'
export const SAVE_PRE_FORM = 'SAVE_PRE_FORM'
export const SEND_PRE_FORM = 'SEND_PRE_FORM'
export const SEND_POST_FORM = 'SEND_POST_FORM'


// WEBPACK FOOTER //
// ./src/constants/chatActionTypes.js